import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

/** The org's Amazon Ads accounts, each with its entity and profile IDs per marketplace. */
export function useAdvertisingAccounts() {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const isConnected = useAppSelector((state) => state.amz_onboard.amazon_advertising_access === "connected");

  return useQuery({
    queryKey: ["advertisingAccounts", marketPlace],
    queryFn: async () => await apiClient.getAdvertisingAccounts({ queries: { marketplace: marketPlace } }),
    select: (data) => data.adsAccounts,
    enabled: isConnected,
  });
}
